<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 30em !important;">
                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/snake.svg" style="height: 10rem !important"/>
                <div class="mt-5" style="font-size: 16px" v-if="status == 'archive'">
                    <div class="mb-4" style="font-size: 20px; color: #f30d0d">Archive</div>
                    <span v-if="origin == 'contacts'">
                        Are you sure want to Archive contact?
                    </span>
                    <span v-else>
                        Do You Want To Archive Selected Data ?
                    </span>
                </div>
                <!-- <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/trash-big.svg" style="height: 10rem !important" v-if="status == 'retrieve'"/> -->
                <div class="mt-5" style="font-size: 16px" v-if="status == 'retrieve'">
                    <div class="mb-4" style="font-size: 20px; color: #f30d0d">Revert</div>
                    Do You Want To Revert Selected Data ?
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn btn-des-small mr-4 px-4 new-no-button" @click="hideSelf">No</button>
                    <button class="btn btn-des-small ml-4 px-4 new-yes-button" @click="confirmArchive">Yes</button>
                </div>
                <div v-else class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn btn-des-small mr-4 px-4" style="background: transparent; color: #0d5be6; border: 1px solid transparent; width: 4em" disabled>No</button>
                    <button class="btn btn-des-small ml-4 px-4" style="background: #005dae; color: #fff; border: 1px solid transparent; width: 4em;position: relative;" disabled>Yes
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { EventBus } from '../eventBus/nav-bar-event';
import { HollowDotsSpinner } from "epic-spinners";
export default {
    props: ["modal_name", "origin"],
    data() {
        return {
            status: 'archive',
            disableButtonAndDisplayLoader: false,
        }
    },
    components: {
        HollowDotsSpinner,
    },
    methods: {
        hideSelf() {
            this.$emit("cancelArchive");
            this.$modal.hide(this.modal_name);
        },
        confirmArchive() {
            this.disableButtonAndDisplayLoader = true;
            this.$emit("archiveData");
            setTimeout(() => {
                this.disableButtonAndDisplayLoader = false;
                this.$modal.hide(this.modal_name);
            }, 1500);
        }
    },
    mounted() {
        EventBus.$on("archive_status",(value) => {
            this.status = value
            // console.log(this.status)
        })
        // console.log(this.origin)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/ArchiveModal.vue